/**
 * True when every run slot is busy and none of the busy runs is the caller's
 * (spec 038 19.6). `ownActive` absent (an older server) or above zero is false,
 * so the existing copy stays.
 */
export function heldByOther(
  active: number | undefined,
  max: number | undefined,
  ownActive: number | undefined,
): boolean {
  if (active === undefined || max === undefined || ownActive === undefined) return false
  return active >= max && ownActive === 0
}
